import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const statusApi = tokenSlice.injectEndpoints({
    reducerPath: 'status',
    baseQuery: createBaseQuery(),
    endpoints(builder) {
        return {
            getStatus: builder.query({
                query: () => {
                    return {
                        url: 'Status/GetAll',
                        method: 'GET'
                    }
                }
            }),
            getStatusList: builder.query({
                query: () => {
                    return {
                        url: 'General/GetStatus',
                        method: 'GET'
                    }
                }
            })
        }
    }
})

export const { useGetStatusQuery, useGetStatusListQuery } = statusApi;
export { statusApi };